import useContextMenu from './useContextMenu'
import { createPortal } from 'react-dom'

const ContextMenu = ({children, targetId}) => {
  const { xPos, yPos, showMenu, closeMenu } = useContextMenu(targetId)
  
  const menuContent = showMenu ? (
    <div
      style={{
        position:"fixed",
        top: yPos,
        left: xPos,
        zIndex:100000,
        border:'solid 1px #e0e0e0'
      }}
      id='commonContextMenu'
      onClick={() => closeMenu()}
    >
      {children}
    </div>
  ) : null;
  
  return menuContent ? createPortal(menuContent, document.body) : null;
};
export default ContextMenu